import { Breadcrumb, BreadcrumbItem, UncontrolledTooltip } from 'reactstrap';
import Link from 'next/link';
import { getThemeColor } from 'store/settings';
import { useSelector } from 'react-redux';
import styled from '@emotion/styled';
import Router from 'next/router';
import { isMobile } from 'react-device-detect';
import ThemeButton from 'components/AntdFormInputs/theme-button';
import { ChevronLeft } from 'react-feather';
import { Tooltip } from 'antd';
const BreadCrumbs = ({ backButton = false, ...props }) => {
  const { data } = props;
  //Color Theme
  const themeStatus = useSelector(getThemeColor);
  const Stylescal = styled.div`
    .content-breadcrumb ol li a:hover {
      color: ${themeStatus} !important;
      text-decoration: underline;
    }
  `;
  return (
    <div className="content-header breadcrumb justify-content-between align-items-center">
      <div className="content-header-left mb-1">
        <div className="breadcrumbs-top">
          <div className="pl-0 margintop">
            {data && data.length ? (
              <Stylescal>
                <div className="breadcrumb-wrapper vs-breadcrumbs d-sm-block col-12 pl-0">
                  <Breadcrumb className="content-breadcrumb">
                    {data.map((item, index) => {
                      const displayText = isMobile
                        ? (item.text || '').substring(0, 5) + '...'
                        : item.text;

                      if (item.active) {
                        return (
                          <BreadcrumbItem key={index} tag="li" active>
                            {displayText}
                          </BreadcrumbItem>
                        );
                      }
                      return (
                        <BreadcrumbItem
                          tag="li"
                          className="text-primary"
                          key={index}
                        >
                          <a onClick={() => Router.push(item?.link || '/')}>
                            {displayText}
                          </a>
                        </BreadcrumbItem>
                      );
                    })}
                  </Breadcrumb>
                </div>
              </Stylescal>
            ) : null}
          </div>
        </div>
      </div>
      {backButton && (
        <ThemeButton
          padding="5px 8px 5px 5px"
          variant="outline"
          alpha={'1a'}
          onClick={() => Router.back()}
          themeSetting={{
            text: 'buttonColor',
          }}
        >
          <span>
            <ChevronLeft size={20} /> Back
          </span>
        </ThemeButton>
      )}
    </div>
  );
};

export default BreadCrumbs;
